import { createFileRoute } from '@tanstack/react-router'
import * as React from 'react'
import { CaseListScreen, type CaseListSearch, parseCaseListSearch } from '../features/queue/case-list-screen'

/** Closed cases (#271): recently closed first, with a close-date range. */
export const Route = createFileRoute('/cases/closed')({
  validateSearch: (raw: Record<string, unknown>): CaseListSearch => parseCaseListSearch(raw),
  component: function CasesClosedRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const onSearch = React.useCallback((next: CaseListSearch) => void navigate({ search: next, replace: true }), [navigate])
    return <CaseListScreen scope="closed" search={search} onSearch={onSearch} />
  },
})
